var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_2575",
    "data-name": "Groupe 2575",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 131.506,
    height: 109.397,
    viewBox: "0 0 131.506 109.397",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2110",
    "data-name": "Rectangle 2110",
    width: 131.506,
    height: 109.397,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_de_masques_2575",
    "data-name": "Groupe de masques 2575",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2977",
    "data-name": "Trac\\xE9 2977",
    d: "M100.966,19.26v.01a7.445,7.445,0,1,1,0-.01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2978",
    "data-name": "Trac\\xE9 2978",
    d: "M116.676,69.03a3.845,3.845,0,0,1-1.01.14h-21.8a4,4,0,0,1-4-4V48.509A1.024,1.024,0,0,1,91.073,47.5a3.784,3.784,0,0,0,3.873-1.571l8.83-12.51a3.345,3.345,0,0,1,.87-.89,3.936,3.936,0,0,1,5.51.84,3.874,3.874,0,0,1,.63,1.29l.02.07,3.92,13.37,2.18,7.4,2.56,8.71a3.94,3.94,0,0,1-2.79,4.82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2979",
    "data-name": "Trac\\xE9 2979",
    d: "M81.649,27.749a7.1,7.1,0,0,0-5.18-2.22H7.4a7.588,7.588,0,0,0-7.4,7.4V102a7.588,7.588,0,0,0,7.4,7.4H76.468a7.588,7.588,0,0,0,7.4-7.4V32.929a7.1,7.1,0,0,0-2.22-5.18M76.468,99.7A2.307,2.307,0,0,1,74.174,102H9.694A2.29,2.29,0,0,1,7.4,99.711V35.223a2.29,2.29,0,0,1,2.286-2.294H74.174a2.307,2.307,0,0,1,2.294,2.294Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2108",
    "data-name": "Rectangle 2108",
    width: 21.285,
    height: 51.052,
    transform: "translate(16.336 41.935)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2109",
    "data-name": "Rectangle 2109",
    width: 21.285,
    height: 22.054,
    transform: "translate(47.633 41.936)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_218",
    "data-name": "Ligne 218",
    x2: 21.285,
    transform: "translate(47.633 78.554)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_219",
    "data-name": "Ligne 219",
    x2: 21.285,
    transform: "translate(47.633 92.771)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2980",
    "data-name": "Trac\\xE9 2980",
    d: "M131.506,7.4V76.47a7.59,7.59,0,0,1-7.4,7.4H93.556a3.686,3.686,0,0,1-3.69-3.51v-.19a4.423,4.423,0,0,1,.07-.74,4.608,4.608,0,0,1,.15-.53,3.063,3.063,0,0,1,.22-.49,3.634,3.634,0,0,1,.64-.86,3.672,3.672,0,0,1,2.61-1.08h28.25a2.3,2.3,0,0,0,2.3-2.29V9.7a2.313,2.313,0,0,0-2.3-2.3H57.316a2.3,2.3,0,0,0-2.28,2.3v6.14a3.7,3.7,0,0,1-7.4,0V7.4a7.59,7.59,0,0,1,7.4-7.4h69.07a7.14,7.14,0,0,1,5.18,2.22,7.157,7.157,0,0,1,2.22,5.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2981",
    "data-name": "Trac\\xE9 2981",
    d: "M89.856,80.17a3.57,3.57,0,0,1,.08-.74,4.423,4.423,0,0,0-.07.74v.19a1.211,1.211,0,0,1-.01-.19",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.8fa53a98cb1e63c6f0d7637c427cc88a.svg";
export { ForwardRef as ReactComponent };